"use client";

import Link from "next/link";
import { CompanionViewAnalytics } from "./_components/CompanionAnalytics";
import { companionSectionLoadFailedEvent } from "@/lib/companion/analytics-events";

export default function CompanionError({
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <main className="min-h-[70vh] bg-warm-bg px-5 py-16 text-charcoal">
      <CompanionViewAnalytics
        event={companionSectionLoadFailedEvent("today-critical", 1)}
      />
      <section
        aria-labelledby="companion-error-heading"
        className="mx-auto max-w-[560px] rounded-lg border border-border-light bg-white p-6 text-center shadow-[0_20px_60px_rgba(22,35,59,0.12)] md:p-8"
      >
        <p className="text-[11px] font-semibold uppercase tracking-[1.6px] text-terracotta">
          Companion unavailable
        </p>
        <h1
          id="companion-error-heading"
          className="mt-2 font-serif text-[30px] leading-tight text-navy"
        >
          We could not load today&apos;s Companion decision.
        </h1>
        <p className="mx-auto mt-3 max-w-[440px] text-[14px] leading-relaxed text-text-muted">
          This is usually temporary. Your saved data has not been deleted.
        </p>
        <div className="mt-6 flex flex-wrap justify-center gap-3">
          <button
            type="button"
            onClick={() => reset()}
            className="inline-flex min-h-[44px] items-center justify-center rounded-sm bg-navy px-5 py-2 text-[14px] font-semibold text-white hover:bg-teal-dark"
          >
            Try again
          </button>
          <Link
            href="/conditions"
            className="inline-flex min-h-[44px] items-center justify-center rounded-sm border border-border bg-white px-5 py-2 text-[14px] font-semibold text-navy no-underline hover:border-teal"
          >
            Open conditions
          </Link>
        </div>
      </section>
    </main>
  );
}
